import { Avatar, Box, Button, Hidden, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useRef } from 'react'

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
)

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.primary.contrastText};
        font-size: 1rem;
        display: block;
`
)

const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};

`
)

const Logo = (): JSX.Element => {
  const ref = useRef<any>(null)
  const user = {
    name: 'Decentrx',
    avatar: 'src/images/logo.svg',
    jobtitle: 'Decentrx'
  }

  return (
    <UserBoxButton color="secondary" ref={ref} size={'large'}>
      <Avatar
        sx={{ width: 64, height: 64 }}
        variant="rounded"
        alt={user.name}
        src={'/static/images/overview/tokyo-logo.png'}
      />
      <Hidden mdDown>
        <UserBoxText>
          <UserBoxLabel variant="body1">{user.name}</UserBoxLabel>
        </UserBoxText>
      </Hidden>
    </UserBoxButton>
  )
}

export default Logo
